import React from 'react';
import { TeasingShell } from '../components/layout/TeasingShell';
import { Callout } from '../components/ui/Callout';
interface TermeniProps {
  navigate: (page: string) => void;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-4298">
      <h2 className="text-lg font-semibold text-light-1 mb-3" data-id="element-4299">{title}</h2>
      <div className="space-y-3" data-id="element-4300">{children}</div>
    </section>;
}
export function Termeni({
  navigate
}: TermeniProps) {
  return <TeasingShell navigate={navigate} data-id="element-4301">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-4302">
        <h1 className="text-3xl sm:text-4xl font-bold text-light-1 mb-2" data-id="element-4303">
          Termeni și Condiții pentru înscrierea pe lista de așteptare IZIO
        </h1>
        <p className="text-sm text-light-4 mb-12" data-id="element-4304">
          Ultima actualizare: 11 iunie 2026
        </p>

        <div className="space-y-10 text-light-2 text-sm leading-relaxed" data-id="element-4305">
          <Section title="1. Introducere și natura proiectului (Faza de validare)" data-id="element-4306">
            <p data-id="element-4307">
              Pagina web de înscriere Izio („Pagina”) este deținută și operată
              de către inițiatorii proiectului Izio (numiți în continuare
              „Operatorul” sau „noi”), acționând în această etapă ca persoane
              fizice în scopul dezvoltării și validării unui concept tehnologic.
            </p>
            <p data-id="element-4308">
              Prezenții termeni și condiții („Termenii”) guvernează utilizarea
              acestei pagini de colectare. Prin introducerea datelor și
              înscrierea pe listă, vă exprimați acordul deplin cu acești
              Termeni.
            </p>
            <Callout variant="tip" title="Important" data-id="element-4309">
              Platforma Izio se află în fază de concept și dezvoltare tehnică
              primară, nefiind disponibilă în prezent ca serviciu public sau
              comercial. Această pagină nu reprezintă o platformă de
              intermediere imobiliară și nu percepe taxe, tarife sau comisioane.
              Ea funcționează exclusiv ca un instrument de studiere a pieței și
              de măsurare a interesului utilizatorilor din România față de
              conceptul propus. În această etapă, nu se prestează niciun fel de
              servicii imobiliare și nu se creează conturi active de utilizator.
            </Callout>
          </Section>

          <Section title="2. Colectarea voluntară a datelor" data-id="element-4310">
            <p data-id="element-4311">
              Pagina vă permite să vă exprimați în mod voluntar interesul pentru
              viitorul proiect, prin înscrierea pe o listă de așteptare.
              Informațiile solicitate sunt minime și includ:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4312">
              <li data-id="element-4313">Prenumele</li>
              <li data-id="element-4314">Adresa de e-mail</li>
              <li data-id="element-4315">
                Tipul de utilizator pe care îl reprezentați (chiriaș, proprietar
                sau agent)
              </li>
            </ul>
            <p data-id="element-4316">
              Aceste date sunt stocate în mod securizat prin intermediul
              platformei tehnice terțe{' '}
              <strong className="text-light-1" data-id="element-4317">
                Loops (Loops Email, Inc., SUA)
              </strong>
              , în deplină conformitate cu clauzele contractuale standard
              stabilite de Uniunea Europeană pentru transferul și protecția
              datelor cu caracter personal.
            </p>
          </Section>

          <Section title="3. Limitele utilizării datelor și garanția de non-marketing" data-id="element-4318">
            <p data-id="element-4319">
              Informațiile colectate în această etapă de cercetare sunt
              utilizate strict pentru:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-4320">
              <li data-id="element-4321">
                Trimiterea de actualizări periodice cu privire la stadiul de
                dezvoltare al proiectului Izio.
              </li>
              <li data-id="element-4322">
                Transmiterea invitațiilor exclusive de participare la testarea
                versiunii de fază timpurie (faza Beta) a aplicației.
              </li>
            </ul>
            <p data-id="element-4323">
              Operatorul garantează că aceste adrese de e-mail{' '}
              <strong className="text-light-1" data-id="element-4324">
                nu vor fi folosite pentru campanii de marketing direct,
                newslettere comerciale sau promovarea altor servicii colaterale
              </strong>{' '}
              care nu au legătură directă cu proiectul Izio.
            </p>
          </Section>

          <Section title="4. Mecanismul de re-autorizare la lansarea oficială" data-id="element-4325">
            <p data-id="element-4326">
              În momentul în care faza de cercetare și studiu de piață se va
              încheia, iar proiectul Izio se va lansa oficial sub o entitate
              juridică comercială proprie (Societate cu Răspundere Limitată),
              această bază de date curentă{' '}
              <strong className="text-light-1" data-id="element-4327">
                nu va fi transferată în mod automat
              </strong>{' '}
              în liste de marketing publicitar sau baze de date comerciale.
            </p>
            <p data-id="element-4328">
              Pentru ca datele dvs. să fie utilizate în noua platformă sau
              pentru a fi incluse în viitoare fluxuri de comunicare
              promoțională, veți primi o nouă solicitare electronică pentru
              exprimarea unui acord explicit (un nou consimțământ activ). Dacă
              alegeți să nu vă exprimați acest nou acord, datele dvs. vor fi
              șterse definitiv din sistemul curent.
            </p>
          </Section>

          <Section title="5. Eligibilitate" data-id="element-4329">
            <p data-id="element-4330">
              Pentru a vă înscrie pe lista de așteptare și a participa la acest
              proces de validare, trebuie să aveți vârsta minimă de 18 ani
              împliniți. Este responsabilitatea dvs. să furnizați o adresă de
              e-mail validă, la care aveți acces direct.
            </p>
          </Section>

          <Section title="6. Beneficiile pentru primii participanți (Statutul de Fondator)" data-id="element-4331">
            <p data-id="element-4332">
              Intenționăm să oferim primilor 100 de participanți care se înscriu
              pe această pagină și acceptă să testeze versiunea timpurie a
              aplicației statutul de{' '}
              <strong className="text-light-1" data-id="element-4333">„Fondator”</strong>. Acest statut
              va include, ca intenție de bunăvoință pentru sprijinul acordat în
              faza de cercetare,{' '}
              <strong className="text-light-1" data-id="element-4334">
                acces gratuit la funcționalitățile de bază
              </strong>{' '}
              ale viitoarei platforme.
            </p>
            <p data-id="element-4335">
              Detaliile tehnice, durata și condițiile specifice de aplicare a
              acestui statut vor fi stabilite și comunicate oficial doar în
              momentul lansării comerciale și pot fi ajustate în mod rezonabil
              pe măsură ce platforma evoluează.
            </p>
          </Section>

          <Section title="7. Lipsa obligațiilor comerciale și financiare" data-id="element-4336">
            <p data-id="element-4337">
              Înscrierea pe lista de așteptare reprezintă o acțiune strict
              voluntară și{' '}
              <strong className="text-light-1" data-id="element-4338">nu vă obligă la nimic</strong>.
              Nu efectuați nicio plată și nu încheiați un contract comercial. Vă
              puteți retrage consimțământul și solicita ștergerea datelor în
              orice moment (conform secțiunii 8).
            </p>
            <p data-id="element-4339">
              Operatorul nu poate garanta o dată fixă de lansare și își rezervă
              dreptul de a modifica, suspenda sau întrerupe proiectul în funcție
              de rezultatele validării. Dacă proiectul nu se materializează
              într-o lansare oficială, toate datele colectate vor fi șterse
              definitiv.
            </p>
          </Section>

          <Section title="8. Retragerea din listă (Dezabonare)" data-id="element-4340">
            <p data-id="element-4341">
              Vă puteți retrage de pe lista de așteptare în orice moment.
              Această acțiune se poate face fie prin accesarea link-ului de
              dezabonare prezent în subsolul fiecărui e-mail primit de la noi,
              fie prin transmiterea unei solicitări scrise la adresa de e-mail
              contact@izio.ro. În urma solicitării, datele dvs. vor fi eliminate
              definitiv din baza de date în maximum 30 de zile.
            </p>
          </Section>

          <Section title="9. Proprietate intelectuală" data-id="element-4342">
            <p data-id="element-4343">
              Prezenta pagină web, elementele de design, logoul Izio, textele,
              structura grafică și conceptele prezentate sunt proprietatea
              exclusivă a inițiatorilor proiectului Izio și sunt protejate de
              legislația privind drepturile de autor. Este strict interzisă
              reproducerea, copierea sau exploatarea acestora în scopuri
              comerciale fără acordul nostru prealabil, exprimat în scris.
            </p>
          </Section>

          <Section title="10. Limitarea răspunderii" data-id="element-4344">
            <p data-id="element-4345">
              Pagina este pusă la dispoziție „ca atare”, în scopuri exclusiv de
              validare de concept. Operatorul nu garantează funcționarea
              neîntreruptă a paginii sau finalizarea obligatorie a proiectului
              comercial. În limita maximă permisă de legea română, Operatorul nu
              va fi considerat responsabil pentru niciun fel de daune rezultate
              din utilizarea acestei pagini de înscriere.
            </p>
          </Section>

          <Section title="11. Modificarea Termenilor" data-id="element-4346">
            <p data-id="element-4347">
              Prezenții Termeni pot fi actualizați periodic pe măsură ce faza de
              validare avansează. Orice versiune nouă va fi publicată direct pe
              această pagină, devenind aplicabilă din momentul postării.
            </p>
          </Section>

          <Section title="12. Legea aplicabilă și litigii" data-id="element-4348">
            <p data-id="element-4349">
              Acești Termeni sunt guvernați în totalitate de legislația din
              România. În cazul apariției oricăror neînțelegeri, acestea vor fi
              soluționate pe cale amiabilă, iar dacă acest lucru nu este
              posibil, competența va reveni instanțelor judecătorești din
              România.
            </p>
          </Section>

          <Section title="13. Contact" data-id="element-4350">
            <p data-id="element-4351">
              Pentru orice întrebări, solicitări de ștergere a datelor sau
              clarificări legate de acești Termeni, ne puteți contacta la adresa
              de e-mail:
            </p>
            <ul className="list-none space-y-1" data-id="element-4352">
              <li data-id="element-4353">Email: contact@izio.ro</li>
            </ul>
          </Section>
        </div>
      </div>
    </TeasingShell>;
}